import { clsx } from 'clsx';
import copy from 'copy-to-clipboard';
import { Job } from '../../interfaces/job';
import { Icon } from '../../../icon/Icon';
import { JOB_MODE_ICON_MAP } from './constants/job-mode-icons';
import { JOB_MODE_BADGE_DATA_IDS } from './constants/data-id';
import { IconButton } from '../../../button/IconButton/IconButton';
import styles from './styles.module.scss';
import { toasterService } from '../../../toaster/toaster.service';
import { useAnalyticsTracker } from '../../../tracking/hooks/useAnalyticsTracker';
import { JobsTrackers } from '../../jobs-trackers';
import { kebabUnderscoreToDisplayString } from '../../../shared/utils/string/formatter';
import { Tooltip } from '../../../tooltip/Tooltip';

export interface JobModeIdBadgeProps {
  mode: Job['mode'];
  jobId: Job['jobId'];
  collapsed?: boolean;
}

export function JobModeIdBadge({ mode, jobId, collapsed }: JobModeIdBadgeProps) {
  const { eventTrack } = useAnalyticsTracker();

  const copyJobId = () => {
    eventTrack({
      action: JobsTrackers.JOB_TRACKER_JOB_MODE_ID_COPY_CLICK
    });

    copy(jobId);

    toasterService.pop('success', undefined, 'Job Id copied to Clipboard');
  };

  return (
    <div className='center-flex-row'>
      {!collapsed ? (
        <>
          <div className='center-flex-row' data-id={JOB_MODE_BADGE_DATA_IDS.mode}>
            <Icon
              dataId={JOB_MODE_BADGE_DATA_IDS.modeIcon}
              name={JOB_MODE_ICON_MAP[mode]}
              size={1}
            />
            <span className='ml-1'>{kebabUnderscoreToDisplayString(mode)}</span>
          </div>

          <span className='ml-2 text-surface-border'>&bull;</span>
          <span className={clsx('text-secondary text-body-1 ml-2')}>Job ID:</span>
        </>
      ) : (
        <Tooltip
          title={kebabUnderscoreToDisplayString(mode)}
          dataId={JOB_MODE_BADGE_DATA_IDS.modeIcon}
        >
          <Icon
            className='mr-1'
            dataId={JOB_MODE_BADGE_DATA_IDS.modeIcon}
            name={JOB_MODE_ICON_MAP[mode]}
            size={1}
          />
        </Tooltip>
      )}

      <Tooltip
        title={kebabUnderscoreToDisplayString(jobId)}
        dataId={JOB_MODE_BADGE_DATA_IDS.jobId}
        disableInteractive={false}
      >
        <span
          data-id={JOB_MODE_BADGE_DATA_IDS.jobId}
          className={clsx(styles.jobId, !collapsed && 'ml-1')}
        >
          ...{jobId.slice(jobId.length - 7, jobId.length)}
        </span>
      </Tooltip>

      {!collapsed ? (
        <IconButton dataId={JOB_MODE_BADGE_DATA_IDS.copy} onClick={copyJobId} label='Copy Job Id'>
          <Icon name='copy' />
        </IconButton>
      ) : null}
    </div>
  );
}
